import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 font-bold mr-2" }, "Erfassungsdatum:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 font-bold mr-2" }, "Service:", -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Bestellung stornieren ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Bestellungen ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_n_time = _resolveComponent("n-time")!
  const _component_n_list_item = _resolveComponent("n-list-item")!
  const _component_n_list = _resolveComponent("n-list")!
  const _component_DismissCircle20Regular = _resolveComponent("DismissCircle20Regular")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_ArrowStepBack20Filled = _resolveComponent("ArrowStepBack20Filled")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_card = _resolveComponent("n-card")!

  return (_ctx.order)
    ? (_openBlock(), _createBlock(_component_n_card, {
        key: 0,
        "theme-overrides": {
      borderColor: _ctx.themeVars.placeholderColor,
    },
        class: "shadow-xl"
      }, {
        header: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, "Bestellung " + _toDisplayString(_ctx.order.order_number), 1)
        ]),
        "header-extra": _withCtx(() => [
          _createVNode(_component_n_tag, {
            type: _ctx.orderStatuses[_ctx.order.status.id],
            class: "rounded-md"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Status: " + _toDisplayString(_ctx.order.status.name), 1)
            ]),
            _: 1
          }, 8, ["type"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_n_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_n_list_item, null, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_component_n_time, {
                    time: new Date(_ctx.order.date_entered),
                    format: "PPP",
                    type: "date"
                  }, null, 8, ["time"])
                ]),
                _: 1
              }),
              _createVNode(_component_n_list_item, null, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createTextVNode(_toDisplayString(_ctx.order.service.translation.name), 1)
                ]),
                _: 1
              }),
              (_ctx.order.service.translation.description)
                ? (_openBlock(), _createBlock(_component_n_list_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        innerHTML: _ctx.order.service.translation.description
                      }, null, 8, _hoisted_4)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        action: _withCtx(() => [
          _createVNode(_component_n_space, {
            justify: _ctx.order.status.id == 1 ? 'space-between' : 'end'
          }, {
            default: _withCtx(() => [
              (_ctx.order.status.id == 1)
                ? (_openBlock(), _createBlock(_component_n_button, {
                    key: 0,
                    type: "tertiary",
                    size: "large",
                    onClick: _ctx.cancelOrder
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_n_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_DismissCircle20Regular)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_n_button, {
                type: "primary",
                size: "large",
                ghost: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routerPush({ path: '/orders' })))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_n_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowStepBack20Filled)
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["justify"])
        ]),
        _: 1
      }, 8, ["theme-overrides"]))
    : _createCommentVNode("", true)
}